"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeTx = void 0;
const request = require("./request");
const result = require("./result");
const transaction = require("./transaction");
const utils_1 = require("./utils");
const coinselect_1 = require("./coinselect");
function composeTx({ txType, utxos, outputs, height, feeRate, basePath, network, changeId, changeAddress, dustThreshold, baseFee, floorBaseFee, dustOutputFee, skipPermutation, }) {
    if (outputs.length === 0) {
        return result.empty;
    }
    if (utxos.length === 0) {
        return { type: 'error', error: 'NOT-ENOUGH-FUNDS' };
    }
    const feeRateNumber = (0, utils_1.convertFeeRate)(feeRate);
    if (!feeRateNumber) {
        return { type: 'error', error: 'INCORRECT-FEE-RATE' };
    }
    let countMax = { exists: false, id: 0 };
    try {
        countMax = request.getMax(outputs);
    }
    catch (e) {
        if (e instanceof Error) {
            return { type: 'error', error: e.message };
        }
        return { type: 'error', error: `${e}` };
    }
    const splitOutputs = request.splitByCompleteness(outputs);
    let csResult = { type: 'false' };
    try {
        csResult = (0, coinselect_1.coinselect)(txType || 'p2pkh', utxos, outputs, height, feeRateNumber, countMax.exists, countMax.id, dustThreshold, network, baseFee, floorBaseFee, dustOutputFee, skipPermutation);
    }
    catch (e) {
        if (e instanceof Error) {
            return { type: 'error', error: e.message };
        }
        return { type: 'error', error: `${e}` };
    }
    if (csResult.type === 'false') {
        return { type: 'error', error: 'NOT-ENOUGH-FUNDS' };
    }
    if (splitOutputs.incomplete.length > 0) {
        return result.getNonfinalResult(csResult);
    }
    const resTransaction = transaction.createTransaction(utxos, csResult.result.inputs, splitOutputs.complete, csResult.result.outputs, basePath, changeId, changeAddress, network, skipPermutation);
    return result.getFinalResult(csResult, resTransaction);
}
exports.composeTx = composeTx;
